import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Home from "./pages/Home/Home";
import AboutRiver from "./pages/AboutRiver/AboutRiver";
import Advisory from "./pages/Advisory/Advisory";
import Investments from "./pages/Investments/Investments";
import Operations from "./pages/Operations/Operations";
import Portfolio from "./pages/Portfolio/Portfolio";

function App() {
    return (
        <Router>
            <ScrollToTop />

            <div className="App">
                <Header />

                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about-river" element={<AboutRiver />} />
                        <Route path="/advisory" element={<Advisory />} />
                        <Route path="/investments" element={<Investments />} />
                        <Route path="/operations" element={<Operations />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                    </Routes>
                </main>

                <Footer />
            </div>
        </Router>
    );
}

export default App;
